import baseLoadable from '@loadable/component';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import { delayPromise } from '@Components/Utilities/SandhillsUtility';

const dynamicLoading = {
    defaultDelayValue: 200
};

const loadable = (importFunc, backdrop = false) => {
    if (backdrop) {
        var importAsyncFunc = importFunc.importAsync;
        importFunc.importAsync = () => {
            var promise = importAsyncFunc();
            return promise.then(delayPromise(dynamicLoading.defaultDelayValue));
        };
        return baseLoadable(importFunc, {
            fallback: (
                <LoadingRing backdrop />
            )
        });
    }

    return baseLoadable(importFunc);
};

export {
    loadable
};